import React, { useRef, useEffect } from 'react';
import './Category.css';

const Category = () => {
  const categories = [
    // {
    //   id: 'chicken-burgers',
    //   name: 'Chicken Burgers',
    //   image: 'https://cdn.pixabay.com/photo/2019/01/21/12/47/burger-3946012_1280.jpg'
    // },
    // {
    //   id: 'beef-burgers',
    //   name: 'Beef Burgers',
    //   image: 'https://cdn.pixabay.com/photo/2022/07/15/18/17/spicy-burger-7323694_1280.jpg'
    // },
    {
      id: 'wings-and-tenders',
      name: 'Wings & Tenders',
      image: 'https://cdn.pixabay.com/photo/2022/11/07/15/47/chicken-wings-7576679_960_720.jpg'
    },
    {
      id: 'corn-dogs',
      name: 'Corn Dogs',
      image: 'https://cdn.pixabay.com/photo/2019/08/24/16/15/corn-dog-4427893_1280.jpg'
    },
    {
      id: 'meal-deals',
      name: 'Meal Deals',
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSnR-OBt49C0aqTEUwP-UJHvFIFaMsvnrggUw&s'
    },
    {
      id: 'curries',
      name: 'Curries',
      image: 'https://cdn.pixabay.com/photo/2020/08/07/19/19/chili-chicken-5471405_1280.jpg'
    },
    {
      id: 'wok-fire-build-your-box',
      name: 'WOK & FIRE Build Your Box',
      image: 'https://cdn.pixabay.com/photo/2016/01/29/17/08/feast-noodles-1168322_960_720.jpg'
    },
    {
      id: 'sides',
      name: 'Sides',
      image: 'https://images.pexels.com/photos/1583884/pexels-photo-1583884.jpeg'
    },
    {
      id: 'drinks',
      name: 'Drinks',
      image: 'https://www.aspris.co.uk/wp-content/uploads/2017/07/Sprite-330ml-scaled.jpg'
    },
    {
      id: 'milkshakes',
      name: 'Milkshakes',
      image: 'https://cdn.pixabay.com/photo/2017/07/20/20/22/smoothie-2523605_960_720.jpg'
    }
  ];

  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollLeft = 0; // Set scroll to start (leftmost) on load
    }
  }, []);

  const handleCategoryClick = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' }); // Added block: 'start' for better alignment
    }
  };

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -200, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 200, behavior: 'smooth' });
    }
  };

  return (
    <section className="category-container" aria-label="Menu Category Navigation">
      <h2 className="category-title">Wok & Fire Halal Menu Categories</h2>
      <div className="category-scroll-container">
        <button
          className="scroll-arrow scroll-arrow-left"
          onClick={scrollLeft}
          aria-label="Scroll left"
        >
          <svg viewBox="0 0 24 24" fill="var(--color-golden)" width="24" height="24">
            <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
          </svg>
        </button>
        <div className="category-scroll" ref={scrollRef}>
          {categories.map((category) => (
            <button
              key={category.id}
              className="category-card"
              onClick={() => handleCategoryClick(category.id)}
              aria-label={`Maps to ${category.name} menu section`}
            >
              <div className="category-image-wrapper">
                <img
                  src={category.image}
                  alt="category-image"
                  title="category-image"
                  className="category-image"
                  loading="lazy"
                  decoding="async"
                />
                <div className="category-overlay"></div>
              </div>
              <span className="category-name">{category.name}</span>
            </button>
          ))}
        </div>
        <button
          className="scroll-arrow scroll-arrow-right"
          onClick={scrollRight}
          aria-label="Scroll right"
        >
          <svg viewBox="0 0 24 24" fill="var(--color-golden)" width="24" height="24">
            <path d="M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z" />
          </svg>
        </button>
      </div>
    </section>
  );
};

export default Category;
